























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ShiftRender from "@/components/render/ShiftRender.vue";
// import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { RenderStageModel } from "@/services/render/types";
import { InteractionTypes, isShift } from "@/services/channels/types";
import MenuRender from "@/components/render/MenuRender.vue";
import { RenderEventBus } from "@/render-event-bus.ts";

@Component({
    name: "stage-render",
    components: {
        ShiftRender,
        MenuRender,
        "content-render-component": () => import("@/components/render/ContentRender.vue")
    }
})
export default class StageRender extends Vue {
    @Prop() private stageRenderModel!: RenderStageModel;
    @Prop({ default: true }) private preview!: boolean;

    renderingModel = {} as RenderStageModel
    dateTime = new Date();
    timer = 0 as number;
    defaultEvent = "";
    isDefaultATemplate = false;
    event = "";
    useStageExpandedDimensions = false as boolean;

    interactionTypes = InteractionTypes;
    isShift = isShift;

    @Watch("stageRenderModel", { deep: true }) t() {
        if (JSON.stringify(this.renderingModel) !== JSON.stringify(this.stageRenderModel)) {
            this.renderingModel = JSON.parse(JSON.stringify(this.stageRenderModel));
            this.unRegisterEvents();
            this.registerEvents();
            this.calculateDefaultContent();
        }
    }

    created() {
        this.renderingModel = JSON.parse(JSON.stringify(this.stageRenderModel));
        this.calculateDefaultContent();
        this.setDefaultContent();
    }

    // lifecycle hooks are used this way to prevent an error
    // On changing i.g. the date, a new stageRender component is created, but it is created before the old one is destroyed.
    // this way to were able to "destroy" the component before the new one is rendered.

    mounted() {
        this.registerEvents();
    }

    beforeUnmount() {
        this.unRegisterEvents();
    }

    beforeDestroy() {
        clearTimeout(this.timer);
    }

    registerEvents() {
        this.renderingModel.channels.forEach(channel => {
            RenderEventBus.$on(channel.eventName, () => {
                this.checkForExpandedDimensions(false);
                this.event = channel.eventName;
                this.startCountdown();
            });
        });
        this.renderingModel.templates.forEach(template => {
            RenderEventBus.$on(template.eventName, () => {
                this.checkForExpandedDimensions(true);
                this.event = template.eventName;
                this.startCountdown();
            });
        });
    }

    unRegisterEvents() {
        this.renderingModel.channels.forEach(channel => {
            RenderEventBus.$off(channel.eventName);
        });
        this.renderingModel.templates.forEach(template => {
            RenderEventBus.$off(template.eventName);
        });
    }

    calculateDefaultContent() {
        this.renderingModel.channels.forEach(channel => {
            if (channel.isDefault) {
                this.checkForExpandedDimensions(false);
                this.defaultEvent = channel.eventName;
                this.isDefaultATemplate = false;
            }
        });
        this.renderingModel.templates.forEach(template => {
            if (template.isDefault) {
                this.checkForExpandedDimensions(true);
                this.defaultEvent = template.eventName;
                this.isDefaultATemplate = true;
            }
        });
        if (this.defaultEvent === "") {
            if (this.renderingModel.channels.length > 0) {
                this.checkForExpandedDimensions(false);
                this.defaultEvent = this.renderingModel.channels[0].eventName;
                this.isDefaultATemplate = false;
            }
            if (this.renderingModel.templates.length > 0) {
                this.checkForExpandedDimensions(true);
                this.defaultEvent = this.renderingModel.templates[0].eventName;
                this.isDefaultATemplate = true;
            }
        }
    }

    startCountdown() {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.setDefaultContent, this.renderingModel.contentTimeout * 1000);
    }

    setDefaultContent() {
        this.checkForExpandedDimensions(this.isDefaultATemplate);
        this.event = this.defaultEvent;
    }

    menuChannelActivity() {
        this.startCountdown();
    }

    checkForExpandedDimensions(isTemplate: boolean) {
        // alert(this.renderingModel.useExpandedDimensionsForTemplate);
        if (isTemplate && this.renderingModel.useExpandedDimensionsForTemplate) {
            this.useStageExpandedDimensions = true;
        } else this.useStageExpandedDimensions = false;
        this.$emit("expandedDimensions", this.useStageExpandedDimensions);
    }

    // computed
    get dynamicStyle() {
        if (this.useStageExpandedDimensions) {
            return {
                height: `${this.renderingModel.expandedHeight}px`,
                width: `${this.renderingModel.expandedWidth}px`
            };
        } else {
            return {
                height: `${this.renderingModel.height}px`,
                width: `${this.renderingModel.width}px`
            };
        }
    }

    getContentStyle() {
        return {
            position: "absolute",
            top: `${this.renderingModel.ypos}px`,
            left: `${this.renderingModel.xpos}px`,
            "z-index": this.renderingModel.layer
        };
    }
}
